import React from "react";
import { Box, Container } from "@mui/material";
import SlideContent from "./SlideContent";

import defaultIndexBg from "../../../assets/centrum_assets/design/index/firstBGS.png";
import defaultIndexBgMin from "../../../assets/centrum_assets/design/index/firstBGmin.png";

const InvertedSlide = ({ item, defaultBg }) => {
    const desktopBg = item.image || defaultBg?.inverted_bg || defaultIndexBg;
    const mobileBg = item.mobile_image || defaultBg?.inverted_mobile || defaultIndexBgMin;

    let vis = {
        headline: { desktop: true, mobile: true },
        subheadline: { desktop: true, mobile: true },
        body: { desktop: true, mobile: true },
        button: { desktop: true, mobile: true },
    };

    if (item.visibility && typeof item.visibility === 'object') {
        vis = item.visibility;
    } else if (typeof item.visibility === 'string' && item.visibility.startsWith('{')) {
        try { vis = JSON.parse(item.visibility); } catch (e) {}
    }

    const hasDesktopContent = Boolean(
        (item.title && vis.headline?.desktop !== false) || 
        (item.subtitle && vis.subheadline?.desktop !== false) || 
        (item.description && vis.body?.desktop !== false) || 
        (item.button_text && item.link_to && vis.button?.desktop !== false)
    );

    const hasMobileContent = Boolean(
        (item.title && vis.headline?.mobile !== false) || 
        (item.subtitle && vis.subheadline?.mobile !== false) || 
        (item.description && vis.body?.mobile !== false) || 
        (item.button_text && item.link_to && vis.button?.mobile !== false)
    );

    return (
        <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
            
            {/* DESKTOP */}
            <Box component="img" src={desktopBg} sx={{ width: "100%", height: "100%", objectFit: "cover", display: { xs: "none", lg: "block" } }} />
            
            {hasDesktopContent && (
                <Box sx={{
                    position: "absolute", top: "50%", left: "auto", right: "5%",
                    transform: "translateY(-50%)", width: "45%", color: "#002349",
                    display: { xs: "none", lg: "block" }, mt: { xl: -2, lg: 5, xs: 0 },
                    textAlign: "right", zIndex: 10
                }}>
                    <SlideContent item={item} isMobile={false} align="right" />
                </Box>
            )}

            {/* MOBILE */}
            <Box component="img" src={mobileBg} sx={{ width: "100%", height: "auto", objectFit: "cover", display: { xs: "block", lg: "none" } }} />
            
            {hasMobileContent && (
                <Box sx={{ py: 5, px: 5, backgroundColor: "#fff", color: "#002349", display: { xs: "block", lg: "none" }, minHeight: "350px" }}>
                    <Container maxWidth="md" sx={{ px: 0 }}>
                        <SlideContent item={item} isMobile={true} />
                    </Container>
                </Box>
            )}
            
        </Box>
    );
};

export default InvertedSlide;